import { combineReducers } from 'redux';
import { createStore } from 'redux';
import setting from './setting';

const store = combineReducers({
  setting,
})

export default createStore(store)
